// Platform Security center — reuses Sessions + LoginAudit from org pages,
// shows them platform-wide because Super Admin gets full visibility.
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import Sessions from "@/pages/org/Sessions";
import LoginAudit from "@/pages/org/LoginAudit";
import MfaSettings from "@/pages/settings/Mfa";
import AuditLog from "@/pages/settings/AuditLog";
import { Card, CardContent } from "@/components/ui/card";

function Coming({ title }) {
  return <Card><CardContent className="p-8 text-center"><h3 className="font-display text-xl font-bold mb-2">{title}</h3><p className="text-muted-foreground text-sm">Configuration UI coming soon. Default platform-wide policy is enforced today.</p></CardContent></Card>;
}

export default function Security() {
  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-4 sm:space-y-6" data-testid="admin-security">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-black">Security center</h1>
        <p className="text-muted-foreground">Login history, active sessions, MFA, password policies, IP allow-list, device management, threat detection and audit trail.</p>
      </div>
      <Tabs defaultValue="login_history">
        <TabsList>
          <TabsTrigger value="login_history" data-testid="sec-tab-login">Login history</TabsTrigger>
          <TabsTrigger value="sessions" data-testid="sec-tab-sessions">Active sessions</TabsTrigger>
          <TabsTrigger value="ip" data-testid="sec-tab-ip">IP allow-list</TabsTrigger>
          <TabsTrigger value="devices" data-testid="sec-tab-devices">Devices</TabsTrigger>
          <TabsTrigger value="mfa" data-testid="sec-tab-mfa">MFA settings</TabsTrigger>
          <TabsTrigger value="pwd" data-testid="sec-tab-pwd">Password policies</TabsTrigger>
          <TabsTrigger value="threats" data-testid="sec-tab-threats">Threat detection</TabsTrigger>
          <TabsTrigger value="audit" data-testid="sec-tab-audit">Audit logs</TabsTrigger>
        </TabsList>
        <TabsContent value="login_history"><LoginAudit /></TabsContent>
        <TabsContent value="sessions"><Sessions /></TabsContent>
        <TabsContent value="ip"><Coming title="IP allow-list" /></TabsContent>
        <TabsContent value="devices"><Coming title="Device management" /></TabsContent>
        <TabsContent value="mfa"><MfaSettings /></TabsContent>
        <TabsContent value="pwd"><Coming title="Password policy editor (use /org/security for per-tenant policy)" /></TabsContent>
        <TabsContent value="threats"><Coming title="Threat detection feed" /></TabsContent>
        <TabsContent value="audit"><AuditLog /></TabsContent>
      </Tabs>
    </div>
  );
}
